import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { MarketingService } from '../../../shared/_services/marketing.service';
import { HcaBookingService } from '../../../shared/_services/hca-booking.service';
import { HcaMemberService } from '../../../shared/_services/hca-member.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';

@Component({
  selector: 'app-create-booking-stay',
  templateUrl: './create-booking-stay.component.html',
  styleUrls: ['./create-booking-stay.component.scss']
})
export class CreateBookingStayComponent implements OnInit {
  memberId: any;
  personTypes: any[] = [];
  hotels: any[] = [];
  errorMsg: string;
  successMsg: string;
  bookingForm: FormGroup;
  srcObject: any = {};
  searchedBookings: any[] = [];
  searchedTransactions: any[] = [];
  isRelatedBookingError: boolean = false;
  bsConfig: Partial<BsDatepickerConfig> = { containerClass: 'theme-orange' };
  bookingTerm$ = new Subject<string>();
  states: any[] = [];

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private marketingService: MarketingService,
    private hcaMemberService: HcaMemberService,
    private hcaBookingService: HcaBookingService
  ) {
    // PROTEGEMOS accesos a this.bookingForm si aún no está inicializado.
    this.hcaMemberService.search(this.bookingTerm$, this.memberId, 'booking', true)
      .subscribe(res => {
        if (res.error == 0) {
          this.searchedBookings = res.responseObj;
          const form = this.bookingForm;
          if (form && this.searchedBookings && this.searchedBookings.length) {
            const current = form.get('bookings') ? form.get('bookings').value : null;
            this.isRelatedBookingError = current ? (this.searchedBookings.indexOf(current) === -1) : false;
          }
        }
      }, err => {
        this.searchedBookings = [];
      });
  }

  private dateRangeValidator = (group: AbstractControl): { [key: string]: any } | null => {
    if (!group) { return null; }
    const ci = group.get('checkInDate') ? group.get('checkInDate').value : null;
    const co = group.get('checkOutDate') ? group.get('checkOutDate').value : null;
    if (ci && co) {
      const ciM = moment(ci).startOf('day');
      const coM = moment(co).startOf('day');
      if (ciM.isAfter(coM)) {
        return { dateRangeInvalid: true };
      }
    }
    return null;
  }

  save() {
    const raw = { ...this.bookingForm.value };

    // Ticket #67117 (regla preservada)
    if (raw.state === '2') {
      raw.isCheckout = true;
    }

    // Formatea fechas a YYYY-MM-DD si existen
    const dataForm: any = {
      ...raw,
      checkInDate: raw.checkInDate ? moment(raw.checkInDate).format('YYYY-MM-DD') : null,
      checkOutDate: raw.checkOutDate ? moment(raw.checkOutDate).format('YYYY-MM-DD') : null
    };

    // (Opcional) normaliza hotel/personType si vienen como objeto en algunos catálogos
    if (typeof dataForm.hotel === 'object' && dataForm.hotel && dataForm.hotel.hotelId) {
      dataForm.hotel = dataForm.hotel.hotelId;
    }
    if (typeof dataForm.personType === 'object' && dataForm.personType && (dataForm.personType.id || dataForm.personType.personTypeId)) {
      dataForm.personType = dataForm.personType.id || dataForm.personType.personTypeId;
    }
    if (typeof dataForm.state === 'object' && dataForm.state && (dataForm.state.id || dataForm.state.value)) {
      dataForm.state = dataForm.state.id || dataForm.state.value;
    }

    // Envío
    this.hcaMemberService.createBookingStays(dataForm).subscribe(res => {
      if (!res || res.error !== 0) {
        this.errorMsg = res && res.message ? res.message : 'Booking stay could not be saved';
        setTimeout(() => {
          this.errorMsg = '';
        }, 1500);
        return;
      }
      this.successMsg = 'Booking stay saved successfully';
      setTimeout(() => {
        this.successMsg = '';
        this.srcObject = {type: 'create-booking-stay', action: 'action1'};
        this.bsModalRef.hide();
      }, 1500);
    }, err => {
      console.error('Error while adding booking stay for member: ', err && err.message);
      this.errorMsg = err && err.message ? err.message : 'Booking stay could not be saved';
      setTimeout(() => {
        this.errorMsg = '';
      }, 1500);
    });
  }

  initForm(memberId?) {
    this.bookingForm = this.fb.group({
      member: [memberId ? parseInt(memberId, 10) : null],
      hotel: [null, Validators.required],
      isCheckout: [false],
      pmsSurName1: [null, Validators.required],
      // NUEVOS CAMPOS
      bookingReference: [null, Validators.required],
      travelAgency: [null],
      checkInDate: [null, Validators.required],
      checkOutDate: [null, Validators.required]
    }, { validator: this.dateRangeValidator });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  selectDropdown(id, type) {
    if (this.bookingForm && this.bookingForm.get('bookings')) {
      this.bookingForm.get('bookings').setValue(id);
    }
    if (this.searchedBookings && this.searchedBookings.length) {
      const bookingIds = this.searchedBookings.map(booking => booking.bookingId);
      this.isRelatedBookingError = bookingIds.indexOf(id) === -1;
    }
  }

  getHotels() {
    this.hcaMemberService.getHotelsByBrand().subscribe(res => {
      if (res.error == 0) {
        this.hotels = res.responseObj;
      }
    }, err => {
      console.error('Error while getting hotels: ', err && err.message);
    });
  }

  getPersonTypes() {
    this.marketingService.getPersonTypes().subscribe(res => {
      if (res.error == 0) {
        this.personTypes = res.responseObj;
      }
    }, err => {
      console.error('Error while getting person types: ', err && err.message);
    });
  }

  getfilterLookUpData() {
    this.hcaBookingService.getLookupDataForBooking().subscribe(res => {
      if (res.error == 0 && res.responseObj && res.responseObj.state && res.responseObj.state.length) {
        this.states = res.responseObj.state;
      }
    }, err => {
      console.error('Error while getting filter look up date: ', err && err.message);
    });
  }

  ngOnInit() {
    this.getPersonTypes();
    this.getHotels();
    this.getfilterLookUpData();
    this.initForm();
    setTimeout(() => {
      if (this.memberId) {
        this.initForm(this.memberId);
      }
    }, 100);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/create-booking-stay/create-booking-stay.component.ts